import React from 'react';
import PropTypes from 'prop-types';
import Header from 'cccisd-header';
import style from './style.css';

const Appdefs = window.cccisd.appDefs;

const NavBar = ({ className }) => {
    const role = window.cccisd.fortress.user.acting.role.handle;
    const isInstructor = role === 'instructor';

    // the "header" nav uses the old { label, url } item format, which cccisd-header can't parse by handle
    let primaryNavLinks = [];
    try {
        primaryNavLinks = Appdefs.navs.find(n => n.handle === 'header').nav;
    } catch (e) {
        // no header nav for this role
    }

    return (
        <Header
            containerClassName={isInstructor ? 'container-fluid' : className}
            logoClassName={isInstructor ? style.instructorLogo : style.textLogo}
            primaryNavLinks={primaryNavLinks}
            showHomeAction={false}
            showAlertAction={false}
        />
    );
};

NavBar.defaultProps = {
    className: 'container',
};

NavBar.propTypes = {
    className: PropTypes.string,
};

export default NavBar;
